// extracted by mini-css-extract-plugin
export default {"team":"team_team__HXD-u","position":"team_position__uHXRa","bio":"team_bio__pa3xF"};